// src/plugins/google-maps.js
let initialized = false;
let googleInstance = null;

export default {
  async install(Vue) {
    async function waitFor(checkFn, timeout = 5000, interval = 50) {
      return new Promise((resolve, reject) => {
        const start = Date.now();
        const timer = setInterval(() => {
          if (checkFn()) {
            clearInterval(timer);
            resolve();
          } else if (Date.now() - start > timeout) {
            clearInterval(timer);
            reject(new Error('google.maps.importLibrary não disponível.'));
          }
        }, interval);
      });
    }

    async function loadGoogleMapsAPI(apiKey) {
      if (!apiKey) {
        throw new Error('Google Maps API key não fornecida a init().');
      }

      if (initialized) return;

      const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');

      if (!existingScript) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=weekly&loading=async`;
          script.async = true;
          script.defer = true;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      await waitFor(() => !!window.google?.maps?.importLibrary);
      await window.google.maps.importLibrary('places');

      googleInstance = window.google;
      initialized = true;
    }

    Vue.prototype.$googleMaps = {
      async init(key) {
        return await loadGoogleMapsAPI(key);
      },

      get google() {
        if (!googleInstance) {
          throw new Error('Google Maps ainda não carregado.');
        }
        return googleInstance;
      },

      getSessionToken() {
        if (!googleInstance?.maps?.places) {
          throw new Error('Places API não carregada.');
        }
        return new googleInstance.maps.places.AutocompleteSessionToken();
      },
    };
  },
};
